import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { Route as RootRoute } from "../__root"

/**
 * New shipment -- `/shipments/new`.
 *
 * Registered ahead of `/shipments/$shipmentId` in `router.tsx`. TanStack
 * ranks static segments above dynamic ones, so `new` is not swallowed by
 * `$shipmentId`, but the ordering is kept explicit so a future reshuffle
 * doesn't quietly turn this into a detail lookup for a shipment called
 * "new".
 *
 * Code-split like the detail route: the form pulls the carrier / lane /
 * vertical / country registries and their schemas, none of which the list
 * view should pay for.
 */
export const Route = createRoute({
	getParentRoute: () => RootRoute,
	path: "/shipments/new",
	component: lazyRouteComponent(() => import("./new.page")),
})
